export const ABORT_SIGNAL_NAME = { contractorsContextAvailableBookingWorkflow: 'contractorsContext::availableBookingWorkflow' };
